import { css } from 'styled-components'

export const Widget = css`
  color: var(--color-strongText);
  margin: 0;
`
